import React, {useState} from 'react';
import {colors} from 'src/assets';
import {BottomActions, Button} from 'src/components';
import LocalText from 'src/local';

export enum ActionsLayout {
  WaitingAnswer,
  WaitingAnswerCancel,
  AnswerRequired,
  WaitingTalkConnectionBySender,
  WaitingTalkConnectionByReceiver,
  Talk,
}

export type ActionsProps = {
  layout: ActionsLayout;
  leftBtnLoading?: boolean;
  leftBtnDisabled?: boolean;
  onLeft?: () => void;
  rightBtnLoading?: boolean;
  rightBtnDisabled?: boolean;
  onRight?: () => void;
};

export const Actions: React.FC<ActionsProps> = ({
  layout,
  leftBtnLoading,
  leftBtnDisabled,
  onLeft,
  rightBtnLoading,
  rightBtnDisabled,
  onRight,
}) => {
  return (
    <React.Fragment>
      {layout === ActionsLayout.WaitingAnswer && (
        <BottomActions>
          <Button
            variant={'secondary'}
            icon={'hide'}
            iconColor={colors.chokuRed}
            title={LocalText.screens.call.actions.hide}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
          <Button
            variant={'primary'}
            icon={'minus-circle'}
            title={LocalText.screens.call.actions.abort}
            onPress={onRight}
            loading={rightBtnLoading}
            disabled={rightBtnDisabled}
          />
        </BottomActions>
      )}
      {layout === ActionsLayout.WaitingAnswerCancel && (
        <BottomActions>
          <Button
            variant={'secondary'}
            icon={'cancel'}
            iconColor={colors.chokuRed}
            title={LocalText.common.cancel}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
          <Button
            variant={'primary'}
            icon={'check'}
            title={LocalText.screens.call.actions.sendAndFinish}
            onPress={onRight}
            loading={rightBtnLoading}
            disabled={rightBtnDisabled}
          />
        </BottomActions>
      )}
      {layout === ActionsLayout.AnswerRequired && (
        <BottomActions>
          <Button
            variant={'secondary'}
            icon={'minus-circle'}
            iconColor={colors.chokuRed}
            title={LocalText.screens.call.actions.reject}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
          <Button
            variant={'primary'}
            icon={'call'}
            title={LocalText.screens.call.actions.talk}
            onPress={onRight}
            loading={rightBtnLoading}
            disabled={rightBtnDisabled}
          />
        </BottomActions>
      )}
      {layout === ActionsLayout.WaitingTalkConnectionBySender && (
        <BottomActions>
          <Button
            variant={'secondary'}
            icon={'call-end'}
            iconColor={colors.chokuRed}
            title={LocalText.screens.call.actions.finish}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
          <Button
            variant={'primary'}
            icon={'call'}
            title={LocalText.screens.call.actions.talk}
            onPress={onRight}
            loading={rightBtnLoading}
            disabled={rightBtnDisabled}
          />
        </BottomActions>
      )}
      {layout === ActionsLayout.WaitingTalkConnectionByReceiver && (
        <BottomActions>
          <Button
            variant={'primary'}
            icon={'call-end'}
            title={LocalText.screens.call.actions.finish}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
        </BottomActions>
      )}
      {layout === ActionsLayout.Talk && (
        <BottomActions>
          <Button
            variant={'primary'}
            icon={'call-end'}
            title={LocalText.screens.call.actions.finish}
            onPress={onLeft}
            loading={leftBtnLoading}
            disabled={leftBtnDisabled}
          />
        </BottomActions>
      )}
    </React.Fragment>
  );
};
